import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import type { TENANTSINTERFACE } from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TENANTS_INFO } from '@fitness-force/state';
import { PaymentGatewayMasterService } from '@fitness-force/api';
import { loadPayengine } from 'payengine';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Component({
  selector: 'disputemanagement',
  templateUrl: './disputemanagement.component.html',
  styleUrls: ['./disputemanagement.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ProgressSpinnerModule, AsyncPipe],
})
export class DisputemanagementComponent implements OnInit {
  private store = inject(Store);
  private paymentGatewayMasterService = inject(PaymentGatewayMasterService);
  private cd = inject(ChangeDetectorRef);

  showSkeleton$: BehaviorSubject<boolean> = new BehaviorSubject(
    true as boolean,
  );
  getAccessTenantList$: Observable<TENANTSINTERFACE> = new Subject();
  tenantId = 0;

  loading = new BehaviorSubject<boolean>(true);

  HMACSHA256: BehaviorSubject<string> = new BehaviorSubject('' as string);
  MERCHANTID: BehaviorSubject<string> = new BehaviorSubject('' as string);
  GATEWAYID: BehaviorSubject<string> = new BehaviorSubject('' as string);
  PUBLICKEY: BehaviorSubject<string> = new BehaviorSubject('' as string);

  payEngine: any;

  constructor() {
    this.loading.next(true);
  }

  async ngOnInit(): Promise<void> {
    this.componentInit();
  }

  componentInit() {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.getPaymentGatewayList();
      }
    });
  }

  get merchant() {
    return this.MERCHANTID.getValue();
  }

  get hash() {
    return this.HMACSHA256.getValue();
  }

  getPaymentGatewayList() {
    this.paymentGatewayMasterService
      .getPaymentGatewayMasterHMAC(this.tenantId)
      .subscribe({
        next: async (response: any) => {
          this.HMACSHA256.next(response.hmac);
          this.MERCHANTID.next(response.merchant_id);
          this.GATEWAYID.next(response.gateway_id);
          this.PUBLICKEY.next(response.public_key);
          this.payEngine = await loadPayengine({
            publicKey: this.PUBLICKEY.value,
          });
          document.getElementById('hidPayEng')!.innerHTML =
            `<pay-engine  id="cardID" merchant-id=${response.merchant_id}  type="disputes"
        hmac=${response.hmac} (success)="onSuccess($event)" (error)="onError($event)">
        </pay-engine>`;
          //await this.timeout(6000);
          this.loading.next(false);
          this.cd.detectChanges();
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
